<template>
  <PackageExpansionsManagerUI
    v-loading="loading"
    :main-obb-files="mainObbFiles"
    :patch-obb-files="patchObbFiles"
    :attached-main-obb="attachedMainObb"
    :attached-patch-obb="attachedPatchObb"
    :main-obb-upload-path="mainObbUploadPath"
    :patch-obb-upload-path="patchObbUploadPath"
    :error-message="errorMessage"
    @change="attachObbToPackage"
    @detach="detachObb"
  />
</template>

<script>
import PackageExpansionsManagerUI from '@@/app/common/PackageExpansionsManagerUI';
import { DraftApps } from '@/api/api';
import { apiPath } from '@/api/constants';
import { mapActions, mapGetters } from 'vuex';
import { DRAFT_APP } from '@/store/types';
import { UPDATE_DRAFT_APP } from '../../../../../store/types';

export default {
  name: 'NewAppPackageExpansionsManager',
  components: { PackageExpansionsManagerUI },

  props: {
    packageId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      mainObbFiles: [],
      patchObbFiles: [],
      errorMessage: '',
      loading: false,
    };
  },

  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
    packageItem() {
      return this.draftApp?.packages?.find(pkg => pkg.id === this.packageId);
    },
    attachedMainObb() {
      const isMainExpansion = ({ fileType }) => fileType === 'M';
      const file = this.packageItem?.additionalFiles?.find(isMainExpansion);
      return file?.id;
    },
    attachedPatchObb() {
      const isPatchExpansion = ({ fileType }) => fileType === 'P';
      const file = this.packageItem?.additionalFiles?.find(isPatchExpansion);
      return file?.id;
    },
    mainObbUploadPath() {
      return `${apiPath}/draft-apps/${this.draftApp.id}/upload/main-obb/`;
    },
    patchObbUploadPath() {
      return `${apiPath}/draft-apps/${this.draftApp.id}/upload/patch-obb/${this.attachedMainObb}/`;
    },
  },

  watch: {
    attachedMainObb() {
      this.getPatchObbs();
    },
  },

  created() {
    this.getMainObbs();
    this.getPatchObbs();
  },

  methods: {
    ...mapActions({ updateDraftApp: UPDATE_DRAFT_APP }),

    getMainObbs() {
      this.errorMessage = '';
      this.loading = true;

      return DraftApps.getMainObbs(this.draftApp.id)
        .then(({ data }) => {
          this.mainObbFiles = data;
        })
        .catch(({ message }) => {
          this.errorMessage = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getPatchObbs() {
      if (!Number.isInteger(this.attachedMainObb)) return;

      this.errorMessage = '';
      this.loading = true;

      return DraftApps.getPatchObbs({
        id: this.draftApp.id,
        mainObbId: this.attachedMainObb,
      })
        .then(({ data }) => {
          this.patchObbFiles = data;
        })
        .catch(({ message }) => {
          this.errorMessage = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    attachObbToPackage(obbId) {
      this.errorMessage = '';
      this.loading = true;

      return DraftApps.attachObbToPackage({
        id: this.draftApp.id,
        packageId: this.packageId,
        obbId,
      })
        .then(({ message, draftApp }) => {
          this.$message.success(message);
          this.updateDraftApp(draftApp);
        })
        .catch(({ message }) => {
          this.errorMessage = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    detachObb(obbId) {
      this.loading = true;

      return DraftApps.detachObbfromPackage({
        id: this.draftApp.id,
        packageId: this.packageItem.id,
        obbId,
      })
        .then(({ message, draftApp }) => {
          this.$message.success(message);
          this.updateDraftApp(draftApp);
        })
        .catch(({ message }) => {
          this.errorMessage = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
